import { render, staticRenderFns } from "./NavDescription.vue?vue&type=template&id=2fd0a3fe&scoped=true&"
import script from "./NavDescription.vue?vue&type=script&lang=js&"
export * from "./NavDescription.vue?vue&type=script&lang=js&"
import style0 from "./NavDescription.vue?vue&type=style&index=0&id=2fd0a3fe&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fd0a3fe",
  null
  
)

export default component.exports